







































import Vue from "vue";
import { WorkRecordServiceProxy } from "@/service-proxies/app-v2/work-record.service-proxies";
import { TaskServiceProxy } from "@/service-proxies/app-v2/flow.service-proxies";
const workRecordService = new WorkRecordServiceProxy();
const taskService = new TaskServiceProxy();

const options = [
  { label: "通过", value: "pass" },
  { label: "退回", value: "back" },
];

export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        auditResult: "pass",
        comment: "",
        backNode: "",
      },
      options,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      taskId: "",
      workRecordId: "",
      processProgress: "",
      showBackList: false,
      backNodeOptions: [],
      rules: {
        comment: [
          { required: true, message: this.$t('page_ops_work_record_audit_required'), trigger: "change" },
        ],
      },
    };
  },
  methods: {
    async initData(record) {
      this.taskId = record.currentTaskId;
      this.workRecordId = record.id;
      this.customerId = record.customerId;
      this.processProgress = record.processProgress;

      const nodes = await taskService.backNodes(this.taskId);
      this.backNodeOptions = nodes.map((item) => {
        return { label: item.nodeName, value: item.nodeId };
      });
      this.form.backNode = nodes[nodes.length - 1].nodeId;
    },
    auditResultChange(item) {
      this.showBackList = item.target.value !== "pass";
    },
    save() {
      this.$refs.auditForm.validate((valid) => {
        if (valid) {
          if (this.form.auditResult === "pass") {
            const params: any = {
              comments: this.form.comment,
              processProgress: this.processProgress,
              processUserIds: [],
              taskId: this.taskId,
              workRecordId: this.workRecordId,
            };

            workRecordService.processWorkRecord(params).then((res) => {
              this.$message.success(this.$t("success"));
              this.reset();
              this.$emit("cancel", true);
            });
          } else {
            const params: any = {
              activityId: this.form.backNode,
              activityName: this.backNodeOptions.find(
                (x) => x.value === this.form.backNode
              ).label,
              message: this.form.comment,
              taskId: this.taskId,
              workRecordId: this.workRecordId,
            };

            workRecordService.backWorkRecord(params).then((res) => {
              this.$message.success(this.$t("success"));
              this.reset();
              this.$emit("cancel", true);
            });
          }
        }
      });
    },
    reset() {
      this.form.auditResult = "pass";
      this.form.comment = "";
      this.form.backNode = "";
      this.showBackList = false;
    },
  },
});
